import {
    StyleSheet
} from "react-native";
import type {
    ChartKeyMeasuresConstantType,
    ChartKeyMeasures
} from "./type";

export const getChartKeyMeasures = ({
    shapeConfigs,
    iconSizes,
    radiuses,
    borders,
    length,
    shape,
    isOff
}: ChartKeyMeasuresConstantType): ChartKeyMeasures => {
    const side = shapeConfigs.chartDotSize;

    if(shape === "line") {
        return {
            width: length ?? iconSizes.small - borders.indicator,
            radius: isOff ? radiuses.xs / 2 : radiuses.full,
            height: isOff ? side : borders.chartLine
        };
    }

    return {
        radius: shape === "dot" ? radiuses.full : radiuses.xs / 2,
        height: side,
        width: side
    };
};

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0
    }
});
export default stylesheet;
